module.exports = __webpack_public_path__ + "static/media/inbox-in.61458717.svg";